export default __webpack_public_path__ + "static/media/state-of-design-1.5x.3022eacf.png";